import variables from "styles/util/variables";

const { palette } = variables;

export const getBorderColor = (unavailable?: boolean, depleted?: boolean) => {
  if (unavailable) return palette["gray-s0-l30-a40"];
  if (depleted) return palette["red-s95-l65"];
  return palette["light-blue-s10-l60"];
};

export const getTextColor = (unavailable?: boolean, depleted?: boolean) => {
  if (unavailable) return palette["gray-s0-l30-a40"];
  if (depleted) return palette["red-s95-l65"];
  return palette.white;
};

export const getBackgroundColor = (
  unavailable?: boolean,
  depleted?: boolean
) => {
  if (unavailable) return palette["mid-blue-s15-l10"];
  if (depleted) return palette["mid-blue-s15-l20"];
  return palette["mid-blue-s15-l20"];
};
